import React, { memo, useEffect, useMemo, useState } from "react";
import {
	Autocomplete,
	AutocompleteItem,
	Avatar,
	Chip,
	Listbox,
	ListboxItem,
	Modal,
	ModalBody,
	ModalContent,
	ModalHeader,
	Pagination,
	SelectItem,
	Switch,
	Tooltip,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Select,
	Progress,
} from "@heroui/react";
import axios from "axios";
import { CheckIcon } from "../pages/ChatPage";
import { useNavigate } from "react-router";
import UserChip from "./UserChip";

window.getColor = (level) => {
	if (level <= 10) {
		return "#727BB5";
	}
	if (level <= 20) {
		return "#CF86B2";
	}
	if (level <= 30) {
		return "#5EC0F7";
	}
	if (level <= 40) {
		return "#6992FF";
	}
	if (level <= 50) {
		return "#AA78F1";
	}
	if (level <= 60) {
		return "#ED5674";
	}
	if (level <= 70) {
		return "#F58737";
	}
	if (level <= 80) {
		return "#F58837";
	}
	if (level <= 90) {
		return "#F58837";
	}
	if (level <= 40) {
		return "#FF9D55";
	}
};
const ref = React.createRef();
function RankDialog(props) {
	const [data, setData] = React.useState([]);

	window.redirect = useNavigate();

	const fetchData = (key) => {
		if (!key) {
			key = "";
		}
		axios.get("/api/search?type=name&key=" + key).then((response) => {
			setData(response.data.data ?? []);
		});
	};
	const [fans, setFans] = React.useState([]);

	const [page, setPage] = React.useState(1);

	const [liver, setLiver] = React.useState("");

	const [totalPage, setTotalPage] = React.useState(1);

	const SIZE = 100;

	const fetchFans = () => {
		axios
			.get(
				"/api/medals?target_id=" +
					liver?.split("-")[0] +
					`&ps=${SIZE}&pn=` +
					page,
			)
			.then((response) => {
				setFans(response.data.items);
				if (response.data.total % SIZE === 0) {
					setTotalPage(response.data.total / SIZE);
				} else {
					setTotalPage(Math.floor(response.data.total / SIZE) + 1);
				}

				if (ref.current) {
					const element = ref.current.children[0].children[0];
					element.scrollTop = 0;
					console.log(
						"top ",
						element.scrollTop,
						"height ",
						element.height,
					);
				}
			});
	};

	useEffect(() => {
		fetchFans();
	}, [page, liver]);

	useEffect(() => {
		fetchData();
	}, []);
	return (
		<div>
			<Modal
				isOpen={props.open}
				onClose={() => {
					setData([]);

					props.onClose();
				}}
				size="lg"
				scrollBehavior={"inside"}
			>
				<ModalContent>
					<ModalHeader className="flex flex-col gap-1">
						Rank
					</ModalHeader>
					<ModalBody>
						<div className="flex flex-col ">
							<div className={"flex flex-row gap-1"}>
								<Autocomplete
									className="max-w-xs"
									defaultItems={data}
									label="Search"
									labelPlacement="inside"
									placeholder="主播"
									isVirtualized={false}
									onInputChange={(value) => {
										fetchData(value);
									}}
									onSelectionChange={(value) => {
										setLiver(value);
										setPage(1);
									}}
								>
									{(user) => (
										<AutocompleteItem
											key={`${user.UID}-${user.LiverID}`}
											textValue={user.UName}
										>
											<div className="flex gap-2 items-center">
												<Avatar
													className="flex-shrink-0"
													size="sm"
													src={`${AVATAR_API}${user.UID}`}
												></Avatar>

												<div className="flex flex-col">
													<span className="text-small">
														{user.UName}
													</span>
													{/*	<span className="text-tiny text-default-400">
														{user.UName}
													</span>*/}
												</div>
											</div>
										</AutocompleteItem>
									)}
								</Autocomplete>
							</div>

							<FansList
								fans={fans}
								onClose={props.onClose}
								inspect={props.inspect}
							/>
							<Pagination
								initialPage={1}
								total={totalPage}
								className="content-center"
								onChange={(e) => {
									setPage(e);
								}}
							/>
						</div>
					</ModalBody>
				</ModalContent>
			</Modal>
		</div>
	);
}

export const FansList = memo(function FansList({
	fans,
	onClose,
	height,
	onItemClick,
	inspect,
}) {
	const [open, setOpen] = React.useState(false);
	const [id, setId] = React.useState(0);
	const getStyle = (e) => {
		if (e === "add") {
			return "bg-green-200 rounded-lg px-2 py-2";
		}
		if (e === "remove") {
			return "bg-red-200 rounded-lg px-2 py-2";
		}
		return "";
	};
	return (
		<Listbox
			style={
				{
					//maxHeight: "800px",
					//"overflow-y": "scroll",
				}
			}
			ref={ref}
			onClick={(e) => {
				setOpen(false);
			}}
			onMouseLeave={() => setOpen(false)}
		>
			{fans.map((f) => (
				<ListboxItem
					key={f.UID + "-" + f.LiverID}
					className={"py-2 !h-auto"}
				>
					<Tooltip
						content={
							<div>
								{
									<Dropdown>
										<DropdownMenu aria-label="Static Actions">
											<DropdownItem
												key="new"
												onClick={() => {
													window.open(
														"https://space.bilibili.com/" +
															f.UID,
													);
												}}
											>
												Bilibili
											</DropdownItem>
											<DropdownItem
												key="copy"
												onClick={() => {
													window.open(
														"/user/" + f.UID,
													);
												}}
											>
												vtbCat
											</DropdownItem>
										</DropdownMenu>
									</Dropdown>
								}
							</div>
						}
						isOpen={open && id === f.UID + "-" + f.LiverID}
					>
						<div
							className={getStyle(f.Label)}
							onContextMenu={(e) => {
								e.preventDefault();
								setId(f.UID + "-" + f.LiverID);
								setOpen(!open);
							}}
						>
							<p
								className={`text-medium ${inspectGuard(f) && inspect ? "line-through" : ""}`}
							>
								{f.UName}
							</p>
							{
								<div
									className={"flex flex-row align-middle "}
									onClick={() => {
										onItemClick(f);
									}}
								>
									<UserChip props={convert(f)} />
								</div>
							}
						</div>
					</Tooltip>
				</ListboxItem>
			))}
		</Listbox>
	);
});

const convert = (item) => {
	item.MedalLevel = item.Level;
	if (!item.FromId) {
		item.FromId = item.UID;
	}
	if (item.Type) {
		item.GuardLevel = item.Type;
	}
	return item;
};

export default RankDialog;

const newAxios = axios.create();

export const MoneyRankDialog = (props) => {

	const generateMonths = () => {
		const list = [];
		const now = new Date();
		const currentYear = now.getFullYear();
		const currentMonth = now.getMonth() + 1; // 1 ~ 12
		let y = currentYear;
		let m = currentMonth;
		// 循环递减到 2025年10月
		while (y > 2025 || (y === 2025 && m >= 10)) {
			const monthStr = m < 10 ? `0${m}` : `${m}`;
			list.push({
				key: `${y}-${monthStr}.json`,
				label: `${y}-${monthStr}`,
			});
			m--;
			if (m < 1) {
				m = 12;
				y--;
			}
		}
		list.push({
			key: "overall.json",
			label: "全量",
		});
		return list;
	};

	const ref = React.createRef();

	const PAGE_SIZE = 100;

	const [page, setPage] = React.useState(1);

	const [data, setData] = React.useState([]);

	const [month, setMonth] = React.useState(generateMonths());

	const [selected, setSelected] = React.useState(`2026-10.json`);

	const [loading, setLoading] = React.useState(false);

	const [progress, setProgress] = React.useState(0);

	const [open, setOpen] = React.useState(false);
	const [id, setId] = React.useState(0);


	useEffect(() => {
		console.log(selected);

		if (window.CACHED_FILES.has(selected)) {
			setData(window.CACHED_FILES.get(selected));
		} else {
			setLoading(true);
			var year = selected.replaceAll('.json', '').split('-')[0];
			var month = selected.replaceAll('.json', '').split('-')[1];
			axios({
				url: "/api/rank/cost?year=" + year + "&month=" + month,
				method: "get",
			}).then((res) => {
				setData(res.data.items);
			});
		}
	}, [selected]);

	return (
		<div>
			<Modal
				isOpen={props.open}
				onClose={() => {
					setData([]);

					props.onClose();
				}}
				size="md"
				scrollBehavior={"inside"}
				classNames={{
					body: isMobile() ? "px-0" : "px-3",
				}}
			>
				<ModalContent>
					<ModalHeader className="flex flex-col ">
						"排行榜"
					</ModalHeader>
					<ModalBody className={""} ref={ref}>
						<Select defaultSelectedKeys={["2026-10.json"]}>
							{month.map((item) => (
								<SelectItem
									key={item.key}
									onClick={(e) => {
										setSelected(item.key);
									}}
								>
									{item.label}
								</SelectItem>
							))}
						</Select>

						{(
							<div
								className={
									"overflow-y-scroll overflow-x-hidden"
								}
							>
								<div>
									<Listbox
										style={
											{
												//maxHeight: "800px",
												//"overflow-y": "scroll",
											}
										}
										ref={ref}
										onClick={(e) => {
											setOpen(false);
										}}
										onMouseLeave={() => setOpen(false)}
									>
										{data
											.slice(
												(page - 1) * PAGE_SIZE,
												page * PAGE_SIZE,
											)
											.map((f) => (
												<ListboxItem
													key={f.uid}
													classNames={"py-2"}
												>
													<Tooltip
														content={
															<div>
																{
																	<Dropdown
																		onContextMenu={(
																			e,
																		) => {
																			e.preventDefault();
																		}}
																	>
																		<DropdownMenu aria-label="Static Actions">
																			<DropdownItem
																				key="new"
																				onClick={() => {
																					window.open(
																						"https://space.bilibili.com/" +
																							f.uid,
																					);
																				}}
																				onContextMenu={(
																					e,
																				) => {
																					e.preventDefault();
																				}}
																			>
																				Bilibili
																			</DropdownItem>
																			<DropdownItem
																				key="copy"
																				onClick={() => {
																					window.open(
																						"/user/" +
																							f.UID,
																					);
																				}}
																				onContextMenu={(
																					e,
																				) => {
																					e.preventDefault();
																				}}
																			>
																				vtbCat
																			</DropdownItem>
																		</DropdownMenu>
																	</Dropdown>
																}
															</div>
														}
														isOpen={
															open &&
															id ===
																f.uid +
																	"-" +
																	f.liver_id
														}
													>
														<div
															onContextMenu={(
																e,
															) => {
																e.preventDefault();
																setId(
																	f.uid +
																		"-" +
																		f.liver_id,
																);
																setOpen(!open);
															}}
														>
															<p
																className={`text-medium`}
															>
																{f.u_name}
															</p>
															{
																<div
																	className={
																		"flex flex-row align-middle "
																	}
																	onClick={() => {
																		onItemClick(
																			f,
																		);
																	}}
																>
																	<UserChip2
																		{...f}
																		showGuard={
																			!selected.includes(
																				"overall",
																			)
																		}
																	/>
																</div>
															}
														</div>
													</Tooltip>
												</ListboxItem>
											))}
									</Listbox>
								</div>

								<Pagination
									initialPage={1}
									total={Math.ceil(data.length / PAGE_SIZE)}
									className="content-center mt-2"
									onChange={(e) => {
										setPage(e);
										console.log(ref);
									}}
								/>
							</div>
						)}
					</ModalBody>
				</ModalContent>
			</Modal>
		</div>
	);
};

function UserChip2(props) {
	function process(obj) {
		if (!obj || !Array.isArray(obj.guards)) return obj;

		var g = obj.guards;
		var map = {};
		var uniqueGuards = [];

		for (var i = 0; i < g.length; i++) {
			var item = g[i];
			if (!item || item.uid === undefined) continue;
			var uid = item.uid;
			if (!map[uid]) {
				var newItem = Object.assign({}, item, { count: 1 });
				map[uid] = newItem;
				uniqueGuards.push(newItem);
			} else {
				map[uid].count++;
			}
		}
		return Object.assign({}, obj, { guards: uniqueGuards });
	}
	return (
		<div className={"mt-2 w-full"}>
			<div>
				<p className={"font-semibold w-full"}>{props.FromName}</p>
				{
					<div
						className={
							"flex flex-row align-middle  mb-2  items-center"
						}
					>
						<Avatar
							src={`${AVATAR_API}${props.uid}`}
							onClick={() => {
								//toSpace(props.props.FromId);
								window.open("/user/" + props.uid);
							}}
						/>

						{(props).guards?.length ?  (
							<Tooltip content={<HoverMedals2 {...props} />}>
								<Chip
									startContent={
										props.guards[0].Type ? (
											<img
												src={getGuardIcon(
													props.guards[0].Type,
												)}
												className={'w-5 h-5'}
											/>
										) : (
											<CheckIcon size={18} />
										)
									}
									variant="faded"
									style={{
										background: getColor(
											props.guards[0].Level,
										),
										color: "white",
										marginLeft: "8px",
										marginTop: "4px",

									}}
								>
									<span>{props.guards[0].MedalName}</span>
									<span className="ml-2 text-xs font-bold px-2 py-0.5 rounded-full">
										{props.guards[0].Level}
									</span>
								</Chip>
							</Tooltip>
						) : (
							<></>
						)}
						<div className={"flex items-center"}>
							{props.showGuard &&
								[1, 2, 3].map((typo) => {
									return (
										<>
											<img
												src={getGuardIcon(typo)}
												style={{
													width: "20px",
													height: "20px",
												}}
												className={"ml-1.5"}
											/>
											<span className={"mr-0.5 ml-0.5 font-bold"}>
												{props.guards &&
													props.guards.filter(
														(item) =>
															item.Type === typo,
													).length}
											</span>
										</>
									);
								})}
						</div>
						{!!props.amount && (
							<span className="ml-auto font-bold">
								￥ {parseInt(props.amount).toLocaleString()}
							</span>
						)}
					</div>
				}
			</div>
		</div>
	);
}
function HoverMedals2(props) {
	return (
		<div
			className={
				"flex flex-col overflow-scroll fansMedal overflow-x-hidden"
			}
			style={{ maxHeight: "600px" }}
		>
			{props.guards.map((item, index) => (
				<div key={index} className={"mt-2"}>
					<p className={"font-bold"}>{item.LiverName}</p>

					<div
						className={
							"flex flex-row align-middle mt-2 items-center"
						}
					>
						<Avatar
							src={`${AVATAR_API}${item.LiverID}`}
							onClick={() => {
								toSpace(item.LiverID);
							}}
						/>

						{item.Level ? (
							<Chip
								startContent={
									item.Type ? (
										<img
											src={getGuardIcon(item.Type)}
											className={"w-6 h-6"}
										/>
									) : (
										<div />
									)
								}
								variant="faded"
								onClick={() => {
									toSpace(item.LiverID);
								}}
								style={{
									background:
										new Date().getTime() -
											new Date(item.UpdatedAt) >
										168 * 2 * 3600 * 1000
											? "#5762A799"
											: getColor(item.Level),
									color: "white",
									marginLeft: "8px",
								}}
							>
								{item.MedalName}
								<span className="ml-2 text-xs font-bold px-2 py-0.5 rounded-full">
									{item.Level}
								</span>
							</Chip>
						) : (
							<></>
						)}
					</div>
				</div>
			))}
		</div>
	);
}
